import React from 'react';

import HeroSection from './Components/HeroSection';
import {  UseProductContext } from './Context/productcontext';


const about = () => {
    const {myName}= UseProductContext()
    const data = {
        name: "Rahul About",
      };
  return (
    <div>
        <>
        {myName}
       <HeroSection myData={data} />
       </>
    </div>
  );
}

export default about;
